import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useRef, useEffect } from 'react';
import MessageComponent from './messages.js';
import styles from '../styles/chatbot.module.scss.js';
import Avatar from '@amzn/awsui-chat-components/avatar';
import MaintenancePage from './MaintenancePage.js';
import { useClient } from '../../../client/ClientProvider.js';

const ChatBotContent = ({ messages, handleOptionButtonClick, handleFeedbackButtonClick, showLoadingDots, displayBottom }) => {
    const messagesEndRef = useRef(null);
    const { isHealthy } = useClient();
    useEffect(() => {
        if (!isHealthy)
            return;
        messagesEndRef.current.scrollIntoView({
            behavior: displayBottom ? 'instant' : 'smooth'
        });
    }, [messages, displayBottom, isHealthy]);
    return (jsx("div", { className: styles['chatbot-content'], "data-testid": 'chatbot-content', children: jsxs("div", { className: styles['message-area'], children: [isHealthy && (jsxs(Fragment, { children: [messages.map((msg, index) => (jsx("div", { className: `${styles.message} ${styles[msg.sender]}`, "data-testid": `Message${msg.sender}`, children: jsx(MessageComponent, { msg: msg, handleOptionButtonClick: handleOptionButtonClick, handleFeedbackButtonClick: handleFeedbackButtonClick, showLoadingDots: showLoadingDots }) }, index))), showLoadingDots && (jsxs("div", { className: `${styles.message} ${styles.bot}`, children: [jsx(Avatar, { ariaLabel: 'Avatar of generative AI assistant', color: 'gen-ai', iconName: 'gen-ai', loading: true }), jsx("div", { className: `${styles['bot-response']} ${styles.loading}`, children: jsx("div", { className: styles['message-text'], children: jsx("span", { children: "Generating a response" }) }) })] })), jsx("div", { ref: messagesEndRef })] })), !isHealthy && jsx(MaintenancePage, {})] }) }));
};

export { ChatBotContent as default };
